module.exports = __webpack_public_path__ + "static/TSBK03_projektrapport-247b063190c96a39460fe3d939976d2e.pdf";